import {useEffect} from "react";


const HomeRedirect: React.FC<any> = () => {
  const Redirect = ( ) => {
    return window.location.href="/";
 };
useEffect(() => {
  Redirect();
}, []);
return(<></>);

};

export default HomeRedirect;
